<template>
<div class="left-sidebar">
    <h2>{{productGroup.description}}</h2>
    <div class="panel-body">
      <ul class="product-navigation">
        <template v-for="productCategory in productGroup.productCategories">
          <product-group-navigation-item :productCategory="productCategory" :groupSlug="productGroup.slug" v-bind:key="productCategory.productCategoryId" ></product-group-navigation-item>
        </template>
      </ul>
    </div>
</div>
</template>

<script>
import ProductGroupNavigationItem from './ProductGroupNavigationItem';

export default {
  name: 'product-group-navigation',
  props: ['productGroup'],
  components: {
    'product-group-navigation-item': ProductGroupNavigationItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/ProductGroupNavigation.vue